<!--
  Generated template for the PublicProfilePage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->

<ion-content fullscreen float-nav class="content {{getHeaderShade()}}">
  <ion-header transparent statusbar-raised-padding>
    <ion-toolbar>
    </ion-toolbar>
  </ion-header>
  <image-container height="150px" [src]="'/assets/imgs/profileBackgrounds/'+getProfileBg()"></image-container>

  <ion-card no-margin overflow-all>
    <ion-item no-lines>
      <ion-row>
        <ion-col col-auto no-padding>
          <span [style.background-image]="'url('+profile.profilePicLink+')'" class="user-image-xl offset-top"
            circle></span>
        </ion-col>
        <!-- <ion-col text-right no-padding>
          <button ion-button small clear icon-only (click)="share()">
            <ion-icon name="share"></ion-icon>
          </button>
        </ion-col> -->
      </ion-row>
      <ion-row>
        <ion-col col-12>
          <h1 ion-text text-bold no-margin white-space-normal>{{profile.forName}} {{profile.surName}}</h1>
          <p text-small no-margin *ngIf="profile.city">
            <ion-icon name="pin"></ion-icon> {{profile.city}}
          </p>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col col-7>
          <button *ngIf="!friendExist" ion-button block (click)="addFriend()">
            {{'PUBLICPROFILE_NEW_SPORTFRIEND' | translate}}
          </button>
          <button *ngIf="friendExist" ion-button block (click)="removeFriend()">
            {{'UNFOLLOW_FRIEND' | translate}}
          </button>
        </ion-col>
        <!-- <ion-col col-5>
          <button ion-button block (click)="showActionSheet(profile.id)">
            {{ 'PUBLICPROFILE_DASBINICH' | translate}}
          </button>
        </ion-col> -->
      </ion-row>
    </ion-item>
    <div>
      <ion-segment mode="md" color="dark" [value]="profileTabs" (ionChange)="onChangeProfileTabs($event)">
      <!-- <ion-segment mode="md" color="dark" [(ngModel)]="profileTabs"> -->
        <ion-segment-button value="results">
          {{'PUBLICPROFILE_RESULTS' | translate}}
        </ion-segment-button>

        <ion-segment-button value="routes">
          {{ 'ROUTES_SIMPLE' | translate }}
        </ion-segment-button>
        <!-- <ion-segment-button disabled value="none">
        </ion-segment-button> -->
        <!-- <ion-segment-button disabled value="sportfriends">
          <ion-icon name="people" item-start class="segment-icon"></ion-icon>
        </ion-segment-button>
        <ion-segment-button disabled value="gratulations">
          <ion-icon name="md-thumbs-up" item-start class="segment-icon"></ion-icon>
        </ion-segment-button> -->
      </ion-segment>
    </div>
  </ion-card>

  <div [ngSwitch]="profileTabs">
    <ion-list *ngSwitchCase="'results'">
      <!-- <ion-list-header text-left>
        {{'PUBLICPROFILE_RESULTLIST' | translate}}
      </ion-list-header> -->

      <result-search-list-item *ngFor="let result of profile.resultVec" [displayHead]="false" [result]="result">
      </result-search-list-item>

      <!-- Infinite scroll list -->
    </ion-list>

    <div *ngSwitchCase="'routes'">

      <page-activity-friends [isFriendFeed]="true" [spId]="profile.id"></page-activity-friends>
      <!-- <ion-item-divider color="light">{{'PUBLICPROFILE_SPORTFRIENDS' | translate}}</ion-item-divider> -->
      <!-- Infinite scroll list -->
    </div>

    <ion-list *ngSwitchCase="'sportfriends'">
      <ion-item-divider color="light">{{'PUBLICPROFILE_SPORTFRIENDS' | translate}}</ion-item-divider>
      <!-- Infinite scroll list -->
    </ion-list>

    <ion-list *ngSwitchCase="'gratulations'">
      <ion-item-divider color="light">{{'PUBLICPROFILE_GRATULATIONS' | translate}}</ion-item-divider>

      <!-- Infinite scroll list -->
    </ion-list>
  </div>

</ion-content>